/**
 * Rule ids (R-DL-3, R-BOX-3, R-PS-2 …) are internal references into our own
 * regulatory register. They are how the code and the compliance docs point at a
 * rule; they mean nothing to the person filing a momsdeklaration and must never
 * reach the screen.
 *
 * What is worth showing next to a claim is the source it rests on, named by its
 * publisher — "Skatteverket" tells the user where the link goes, "R-DL-3" does
 * not. Every rule in the register carries a sourceUrl, so the label is derived
 * from that rather than kept in a second table that could drift.
 */
const PUBLISHERS = [
    [/(^|\.)skatteverket\.se/i, 'Skatteverket'],
    [/(^|\.)riksdagen\.se/i, 'Riksdagen'],
    [/(^|\.)bolagsverket\.se/i, 'Bolagsverket'],
    [/(^|\.)bfn\.se/i, 'Bokföringsnämnden'],
    [/(^|\.)bas\.se/i, 'BAS-kontoplanen'],
    [/(^|\.)riksgalden\.se/i, 'Riksgälden'],
];

const DEFAULT_LABEL = 'Läs mer';

export function sourceLabel(url, fallback = DEFAULT_LABEL) {
    if (!url) return fallback;
    let host;
    try {
        host = new URL(url).hostname;
    } catch (e) {
        return fallback;
    }
    const match = PUBLISHERS.find(([pattern]) => pattern.test(host));
    return match ? match[1] : fallback;
}

export default sourceLabel;
